import { useState } from 'react';
import { useSelector } from 'react-redux';
import values from 'ramda/src/values';
import { extendMoment } from 'moment-range';
import originalMoment from 'moment';
import Avatar from '@components/@core/Avatar';
import Icon from '@components/@core/Icon';
import Pagination from '@components/@core/Pagination';
import Rating from '@components/@core/Rating';
import EditDropdown from '@components/EditDropdown';
import { CompanyPerformanceReportMenu } from '~/services/config';
import { inPage } from '~/services/util';

const moment = extendMoment(originalMoment);

const OrgEmployeeList = ({ employees, onReport, onSelectMenu }) => {
    const role = useSelector((state) => state.app.app_role_id);
    const [current, setCurrent] = useState(1);
    const [per, setPer] = useState(10);

    const handlePer = (e) => {
        if (e > 10) setCurrent(1);
        setPer(e);
    };

    return (
        <>
            <div className="list-title mt-2 pb-2 ps-0 desktop-screen">
                <div className="d-flex-4">
                    <span className="dsl-m12">Employee</span>
                </div>
                <div className="d-flex-4">
                    <span className="dsl-m12">Scorecard</span>
                </div>
                <div className="d-flex-1 d-none d-md-block" />
                <div className="d-flex-3">
                    <span className="dsl-m12">Score</span>
                </div>
                <div className="d-flex-2">
                    <span className="dsl-m12">Tasks & Training</span>
                </div>
                <div className="d-flex-2 text-end">
                    <span className="dsl-m12 ">Completed</span>
                </div>
                <div className="d-flex-1 d-none d-md-block" />
            </div>
            {employees?.map((item, index) => {
                let editOptions = [];
                let scorecard = null;
                const data = {
                    scorecards: item?.scorecard ? [item?.scorecard] : [],
                    user: item,
                    performance: item?.performance,
                    company: { id: item?.company_id },
                };
                if (!data.scorecards.length) {
                    editOptions = CompanyPerformanceReportMenu[role].filter(
                        (option) => option !== 'Save Actuals' && option !== 'Start Review' && option !== 'Unassign Scorecard' && option !== 'Save Actuals' && option !== 'Preview Scorecard'
                    );
                } else {
                    editOptions = CompanyPerformanceReportMenu[role].filter((option) => option !== 'Assign Scorecard');
                    scorecard = item.scorecard;
                }
                if (item?.performance?.status === 2) {
                    editOptions = editOptions.filter((option) => option !== 'Save Actuals' && option !== 'Start Review');
                }

                if (inPage(index, current, per)) {
                    return (
                        <div key={item.id} className="d-flex ssm-column list-item">
                            <div className="d-flex-4 d-flex ai-center jc-between w-100 my-2 my-sm-0">
                                <div className="d-flex ai-center">
                                    <Avatar name={`${item?.profile?.first_name} ${item?.profile?.last_name}`} url={item?.avatar} />
                                    <div className="dsl-b14 ms-3 cursor-pointer" onClick={() => onReport(data)}>
                                        {item?.profile?.first_name}&nbsp;{item?.profile?.last_name}
                                    </div>
                                </div>
                                <EditDropdown className="mobile-screen" options={editOptions} onChange={onSelectMenu(data)} />
                            </div>
                            <div className="d-flex-4 truncate cursor-pointer w-100" onClick={() => onReport(data)}>
                                <label className="dsl-b14 mobile-screen w-40">Scorecard</label>
                                <span className="dsl-b14">
                                    {item?.performance?.status == 2 ? values(item?.performance.data.scorecards)[0].title : item?.scorecard ? item?.scorecard?.title : 'No Scorecard Assigned'}
                                </span>
                            </div>
                            <div className="d-flex-1 d-none d-md-block" />
                            <div className="d-flex-3 w-100">
                                <label className="dsl-b14 mobile-screen w-40">Score</label>
                                {item?.performance?.status === 2 ? (
                                    <>
                                        {item?.performance?.data?.completed_average_star_rating === 'N/A' ? (
                                            <span className="dsl-b14">Na (Per Manager)</span>
                                        ) : (
                                            <Rating score={item?.performance?.data?.completed_average_star_rating} />
                                        )}
                                    </>
                                ) : (
                                    <span className="dsl-b14">Incomplete</span>
                                )}
                            </div>
                            <div className="d-flex-2 w-100">
                                <label className="dsl-b14 mobile-screen w-40">Task & Training</label>
                                {item?.performance?.status === 2 && data?.scorecards.length > 0 ? (
                                    <>
                                        <Icon name="fas fa-graduation-cap" color="#343f4b" size={14} />
                                        <span className="dsl-b14 ms-1">{item?.performance?.trainings?.length},</span>
                                        <Icon name="fas fa-circle-check ms-2" color="#343f4b" size={14} />
                                        <span className="dsl-b14 ms-1">{item?.performance?.tasks?.length}</span>
                                    </>
                                ) : (
                                    <span className="dsl-b14">N/A</span>
                                )}
                            </div>
                            <div className="d-flex-2 text-end ssm-left w-100">
                                <label className="dsl-b14 mobile-screen w-40">Completed</label>
                                {item?.performance?.status == 2 ? (
                                    <span className="dsl-b14">{moment(item?.performance.completed_at).format('MMM DD, YY')}</span>
                                ) : (
                                    <span className="dsl-b14">Incomplete</span>
                                )}
                            </div>
                            <div className="d-flex-1 text-end pt-1 desktop-screen">
                                <EditDropdown options={editOptions} onChange={onSelectMenu(data)} />
                            </div>
                        </div>
                    );
                }
            })}
            {employees.length > 10 && (
                <Pagination current={current} total={Math.ceil(employees?.length / per)} per={per} pers={[10, 25, 50, 'all']} onChange={(e) => setCurrent(e)} onPer={handlePer} />
            )}
        </>
    );
};

export default OrgEmployeeList;
